import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { primaryImageStyles } from "@dana/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

primaryImageStyles.primaryImage = mergeToNew(primaryImageStyles.primaryImage, {
    centeringWrapper: {
        css: css`
            min-height: 400px;
            max-height: 450px;
            border: 1px solid ${themeBackgrounds.lightGray};
            margin: 0;
            padding: 16px;
            background: ${themeBackgrounds.white};

            .enlargedImageContainer {
                z-index: 1000;
            }

            @media print {
                min-height: 200px;
                img {
                    max-height: initial !important;
                    height: 170px !important;
                }
            }   
        `,
    },
});

primaryImageStyles.badgeAreaWrapper = mergeToNew(primaryImageStyles.badgeAreaWrapper, {
    css: css`
        
        @media only screen and (min-width: 767px) {
            max-width: 400px;
        }
        .badge-wrapper {
            top: 8px;
            right: -8px;
            overflow: visible;
            text-wrap: auto;

            [class*="TextBadge"] {
                padding: 4px 16px;
                position: relative;

                &::after {
                    content: "";
                    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                    background-repeat: no-repeat;
                    position: absolute;
                    top: -10px;
                    right: -2px;
                    width: 10px;
                    height: 14px;
                    z-index: 5;
                }
            }
        }
    `,
});

primaryImageStyles.obsoleteBadgeWithOverlay = mergeToNew(primaryImageStyles.obsoleteBadgeWithOverlay, {
    css: css`
        background: ${themeBackgrounds.badgeYellow};
        padding: 5px 20px;
        position: absolute;
        z-index: 3;
        right: -8px;
        top: 51px;

        &.has-interchange {
            top: 84px;
        }

        &.no-interchange {
            top: 44px;
        }

        > div {
            position: relative;

            &::after {
                content: "";
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                position: absolute;
                top: -16px;
                right: -22px;
                width: 10px;
                height: 14px;
                z-index: 5;
            }
        }
    `,
});


primaryImageStyles.obsoleteBadgeNoOverlay = mergeToNew(primaryImageStyles.obsoleteBadgeNoOverlay, {
    css: css`
        background: ${themeBackgrounds.badgeYellow};
        padding: 5px 20px;
        position: absolute;
        z-index: 3;
        right: -8px;
        top: 12px;

        &.has-interchange {
            top: 50px;
        }

        > div {
            position: relative;

            &::after {
                content: "";
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                position: absolute;
                top: -16px;
                right: -22px;
                width: 10px;
                height: 14px;
                z-index: 5;
            }
        }
    `,
});


primaryImageStyles.replacedBadgeWrapper = mergeToNew(primaryImageStyles.replacedBadgeWrapper, {
    css: css`
        background: ${themeColors.primary.richBlack};
        padding: 5px 20px;
        position: absolute;
        z-index: 3;
        right: -8px;
        top: 10px;

        &.with-overlay {
            top: 44px;
        }

        &.no-overlay {
            top: 10px;
        }

        > div {
            position: relative;

            &::after {
                content: "";
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='7' height='10' viewBox='0 0 7 10' fill='none'%3E%3Cpath d='M-4.69387e-05 9.78115L-0.000116752 0.781067L7.00007 9.78119L-4.69387e-05 9.78115Z' fill='%23535353'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                position: absolute;
                top: -15px;
                right: -22px;
                width: 10px;
                height: 14px;
                z-index: 5;
            }
        }
    `,
});

primaryImageStyles.obsoleteTitle = mergeToNew(primaryImageStyles.obsoleteTitle, {
    size: fontSizes.xSmall,
    lineHeight: lineHeights.default,
    color: themeColors.danger,
});

primaryImageStyles.replacedBadgeTitle = mergeToNew(primaryImageStyles.replacedBadgeTitle, {
    size: fontSizes.small,
    lineHeight: lineHeights.default,
    color: themeColors.primary.white,
});
